// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `[class^="icon-"], [class*=" icon-"] {
  /* use !important to prevent issues with browser extensions that change fonts */
  font-family: 'icomoon' !important;
  speak: never;
  font-style: normal;
  font-weight: normal;
  font-variant: normal;
  text-transform: none;
  line-height: 1;

  /* Better Font Rendering =========== */
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
.icon-fill-rating:before {
  content: "\\e955";
}
.icon-minus-icon:before {
  content: "\\e900";
}
.icon-user:before {
  content: "\\e901";
}
.icon-trophy:before {
  content: "\\e902";
}
.icon-tick-with-circle:before {
  content: "\\e903";
}
.icon-right-arrow:before {
  content: "\\e904";
}
.icon-left-arrow:before {
  content: "\\e910";
}
.icon-share-from-square:before {
  content: "\\e905";
}
.icon-save:before {
  content: "\\e906";
}
.icon-pencil:before {
  content: "\\e907";
}
.icon-palette:before {
  content: "\\e908";
}
.icon-lightbulb-on:before {
  content: "\\e909";
}
.icon-info-circle:before {
  content: "\\e90a";
}
.icon-graduation-cap:before {
  content: "\\e90b";
}
.icon-edit-copy:before {
  content: "\\e90c";
}
.icon-download-copy:before {
  content: "\\e90d";
}
.icon-circle-arrow-right:before {
  content: "\\e90e";
}
.icon-circle-arrow-left:before {
  content: "\\e90f";
}
.icon-chevron-left:before {
  content: "\\e910";
}
.icon-chevron-right:before {
  content: "\\e919";
}
.icon-briefcase:before {
  content: "\\e911";
}
.icon-brain:before {
  content: "\\e912";
}
.icon-star-icon:before {
  content: "\\e913";
}
.icon-eye-slash:before {
  content: "\\e914";
}
.icon-eye:before {
  content: "\\e915";
}
.icon-download-2:before {
  content: "\\e916";
}
.icon-tick-light:before {
  content: "\\e917";
}
.icon-download:before {
  content: "\\e918";
}
.icon-trash:before {
  content: "\\e919";
}
.icon-link:before {
  content: "\\e91a";
}
.icon-file-text:before {
  content: "\\e91b";
}
.icon-edit:before {
  content: "\\e91c";
}
.icon-arrow-down-light:before {
  content: "\\e91d";
}
.icon-arrow-up-light:before {
  content: "\\e91e";
}
.icon-cross-icon:before {
  content: "\\e91f";
}
.icon-double-arrow-left:before {
  content: "\\e920";
}
.icon-Ellipse-20:before {
  content: "\\e921";
}
.icon-plus-icon:before {
  content: "\\e922";
}
.icon-search-icon:before {
  content: "\\e923";
}
.icon-copy:before {
  content: "\\e924";
}
.icon-double-arrow-right:before {
  content: "\\e925";
}
.icon-calander:before {
  content: "\\e926";
}
.icon-grid:before {
  content: "\\e927";
}
.icon-languages .path1:before {
  content: "\\e928";
  color: rgb(0, 244, 217);
}
.icon-languages .path2:before {
  content: "\\e929";
  margin-left: -1em;
  color: rgb(0, 244, 217);
}
.icon-languages .path3:before {
  content: "\\e92a";
  margin-left: -1em;
  color: rgb(0, 145, 255);
}
.icon-languages .path4:before {
  content: "\\e92b";
  margin-left: -1em;
  color: rgb(42, 100, 173);
}
.icon-volunteers .path1:before {
  content: "\\e92c";
  color: rgb(0, 244, 217);
}
.icon-volunteers .path2:before {
  content: "\\e92d";
  margin-left: -1.0439453125em;
  color: rgb(0, 244, 217);
}
.icon-volunteers .path3:before {
  content: "\\e92e";
  margin-left: -1.0439453125em;
  color: rgb(0, 145, 255);
}
.icon-volunteers .path4:before {
  content: "\\e92f";
  margin-left: -1.0439453125em;
  color: rgb(0, 145, 255);
}
.icon-references .path1:before {
  content: "\\e930";
  color: rgb(0, 244, 217);
}
.icon-references .path2:before {
  content: "\\e931";
  margin-left: -0.919921875em;
  color: rgb(0, 145, 255);
}
.icon-references .path3:before {
  content: "\\e932";
  margin-left: -0.919921875em;
  color: rgb(42, 100, 173);
}
.icon-references .path4:before {
  content: "\\e933";
  margin-left: -0.919921875em;
  color: rgb(0, 145, 255);
}
.icon-references .path5:before {
  content: "\\e934";
  margin-left: -0.919921875em;
  color: rgb(42, 100, 173);
}
.icon-accomplishments .path1:before {
  content: "\\e935";
  color: rgb(0, 244, 217);
}
.icon-accomplishments .path2:before {
  content: "\\e936";
  margin-left: -0.599609375em;
  color: rgb(0, 145, 255);
}
.icon-accomplishments .path3:before {
  content: "\\e937";
  margin-left: -0.599609375em;
  color: rgb(42, 100, 173);
}
.icon-certificates .path1:before {
  content: "\\e938";
  color: rgb(0, 145, 255);
}
.icon-certificates .path2:before {
  content: "\\e939";
  margin-left: -1em;
  color: rgb(0, 145, 255);
}
.icon-certificates .path3:before {
  content: "\\e93a";
  margin-left: -1em;
  color: rgb(0, 145, 255);
}
.icon-certificates .path4:before {
  content: "\\e93b";
  margin-left: -1em;
  color: rgb(0, 244, 217);
}
.icon-certificates .path5:before {
  content: "\\e93c";
  margin-left: -1em;
  color: rgb(0, 244, 217);
}
.icon-certificates .path6:before {
  content: "\\e93d";
  margin-left: -1em;
  color: rgb(0, 244, 217);
}
.icon-certificates .path7:before {
  content: "\\e93e";
  margin-left: -1em;
  color: rgb(42, 100, 173);
}
.icon-custom .path1:before {
  content: "\\e93f";
  color: rgb(0, 145, 255);
}
.icon-custom .path2:before {
  content: "\\e940";
  margin-left: -1.0419921875em;
  color: rgb(0, 145, 255);
}
.icon-custom .path3:before {
  content: "\\e941";
  margin-left: -1.0419921875em;
  color: rgb(0, 244, 217);
}
.icon-custom .path4:before {
  content: "\\e942";
  margin-left: -1.0419921875em;
  color: rgb(42, 100, 173);
}
.icon-custom .path5:before {
  content: "\\e943";
  margin-left: -1.0419921875em;
  color: rgb(0, 145, 255);
}
.icon-custom .path6:before {
  content: "\\e944";
  margin-left: -1.0419921875em;
  color: rgb(0, 145, 255);
}
.icon-custom .path7:before {
  content: "\\e945";
  margin-left: -1.0419921875em;
  color: rgb(0, 244, 217);
}
.icon-custom .path8:before {
  content: "\\e946";
  margin-left: -1.0419921875em;
  color: rgb(42, 100, 173);
}
.icon-custom .path9:before {
  content: "\\e947";
  margin-left: -1.0419921875em;
  color: rgb(0, 145, 255);
}
.icon-custom .path10:before {
  content: "\\e948";
  margin-left: -1.0419921875em;
  color: rgb(0, 145, 255);
}
.icon-custom .path11:before {
  content: "\\e949";
  margin-left: -1.0419921875em;
  color: rgb(0, 244, 217);
}
.icon-custom .path12:before {
  content: "\\e94a";
  margin-left: -1.0419921875em;
  color: rgb(42, 100, 173);
}
.icon-comment-dots:before {
  content: "\\e94b";
  color: #0091ff;
}
.icon-apple .path1:before {
  content: "\\e94c";
  color: rgb(40, 53, 68);
}
.icon-apple .path2:before {
  content: "\\e94d";
  margin-left: -1.0478515625em;
  color: rgb(255, 255, 255);
}
.icon-Facebook .path1:before {
  content: "\\e94e";
  color: rgb(0, 0, 0);
}
.icon-Facebook .path2:before {
  content: "\\e94f";
  margin-left: -1em;
  color: rgb(247, 247, 247);
}
.icon-google .path1:before {
  content: "\\e950";
  color: rgb(66, 133, 244);
}
.icon-google .path2:before {
  content: "\\e951";
  margin-left: -0.9501953125em;
  color: rgb(52, 168, 83);
}
.icon-google .path3:before {
  content: "\\e952";
  margin-left: -0.9501953125em;
  color: rgb(251, 188, 5);
}
.icon-google .path4:before {
  content: "\\e953";
  margin-left: -0.9501953125em;
  color: rgb(235, 67, 53);
}
.icon-tick-small:before {
  content: "\\e954";
  color: #246eed;
}
.icon-blank-rating:before {
  content: "\\e956";
}`, "",{"version":3,"sources":["webpack://./src/assets/fonts/icomoon.css"],"names":[],"mappings":"AAAA;EACE,+EAA+E;EAC/E,iCAAiC;EACjC,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,oBAAoB;EACpB,oBAAoB;EACpB,cAAc;;EAEd,sCAAsC;EACtC,mCAAmC;EACnC,kCAAkC;AACpC;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,uBAAuB;AACzB;AACA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,uBAAuB;AACzB;AACA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,uBAAuB;AACzB;AACA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,wBAAwB;AAC1B;AACA;EACE,gBAAgB;EAChB,uBAAuB;AACzB;AACA;EACE,gBAAgB;EAChB,4BAA4B;EAC5B,uBAAuB;AACzB;AACA;EACE,gBAAgB;EAChB,4BAA4B;EAC5B,uBAAuB;AACzB;AACA;EACE,gBAAgB;EAChB,4BAA4B;EAC5B,uBAAuB;AACzB;AACA;EACE,gBAAgB;EAChB,uBAAuB;AACzB;AACA;EACE,gBAAgB;EAChB,2BAA2B;EAC3B,uBAAuB;AACzB;AACA;EACE,gBAAgB;EAChB,2BAA2B;EAC3B,wBAAwB;AAC1B;AACA;EACE,gBAAgB;EAChB,2BAA2B;EAC3B,uBAAuB;AACzB;AACA;EACE,gBAAgB;EAChB,2BAA2B;EAC3B,wBAAwB;AAC1B;AACA;EACE,gBAAgB;EAChB,uBAAuB;AACzB;AACA;EACE,gBAAgB;EAChB,2BAA2B;EAC3B,uBAAuB;AACzB;AACA;EACE,gBAAgB;EAChB,2BAA2B;EAC3B,wBAAwB;AAC1B;AACA;EACE,gBAAgB;EAChB,uBAAuB;AACzB;AACA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,uBAAuB;AACzB;AACA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,uBAAuB;AACzB;AACA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,uBAAuB;AACzB;AACA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,uBAAuB;AACzB;AACA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,uBAAuB;AACzB;AACA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,wBAAwB;AAC1B;AACA;EACE,gBAAgB;EAChB,uBAAuB;AACzB;AACA;EACE,gBAAgB;EAChB,4BAA4B;EAC5B,uBAAuB;AACzB;AACA;EACE,gBAAgB;EAChB,4BAA4B;EAC5B,uBAAuB;AACzB;AACA;EACE,gBAAgB;EAChB,4BAA4B;EAC5B,wBAAwB;AAC1B;AACA;EACE,gBAAgB;EAChB,4BAA4B;EAC5B,uBAAuB;AACzB;AACA;EACE,gBAAgB;EAChB,4BAA4B;EAC5B,uBAAuB;AACzB;AACA;EACE,gBAAgB;EAChB,4BAA4B;EAC5B,uBAAuB;AACzB;AACA;EACE,gBAAgB;EAChB,4BAA4B;EAC5B,wBAAwB;AAC1B;AACA;EACE,gBAAgB;EAChB,4BAA4B;EAC5B,uBAAuB;AACzB;AACA;EACE,gBAAgB;EAChB,4BAA4B;EAC5B,uBAAuB;AACzB;AACA;EACE,gBAAgB;EAChB,4BAA4B;EAC5B,uBAAuB;AACzB;AACA;EACE,gBAAgB;EAChB,4BAA4B;EAC5B,wBAAwB;AAC1B;AACA;EACE,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,sBAAsB;AACxB;AACA;EACE,gBAAgB;EAChB,4BAA4B;EAC5B,yBAAyB;AAC3B;AACA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,yBAAyB;AAC3B;AACA;EACE,gBAAgB;EAChB,wBAAwB;AAC1B;AACA;EACE,gBAAgB;EAChB,4BAA4B;EAC5B,uBAAuB;AACzB;AACA;EACE,gBAAgB;EAChB,4BAA4B;EAC5B,uBAAuB;AACzB;AACA;EACE,gBAAgB;EAChB,4BAA4B;EAC5B,uBAAuB;AACzB;AACA;EACE,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,gBAAgB;AAClB","sourcesContent":["[class^=\"icon-\"], [class*=\" icon-\"] {\n  /* use !important to prevent issues with browser extensions that change fonts */\n  font-family: 'icomoon' !important;\n  speak: never;\n  font-style: normal;\n  font-weight: normal;\n  font-variant: normal;\n  text-transform: none;\n  line-height: 1;\n\n  /* Better Font Rendering =========== */\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n.icon-fill-rating:before {\n  content: \"\\e955\";\n}\n.icon-minus-icon:before {\n  content: \"\\e900\";\n}\n.icon-user:before {\n  content: \"\\e901\";\n}\n.icon-trophy:before {\n  content: \"\\e902\";\n}\n.icon-tick-with-circle:before {\n  content: \"\\e903\";\n}\n.icon-right-arrow:before {\n  content: \"\\e904\";\n}\n.icon-left-arrow:before {\n  content: \"\\e910\";\n}\n.icon-share-from-square:before {\n  content: \"\\e905\";\n}\n.icon-save:before {\n  content: \"\\e906\";\n}\n.icon-pencil:before {\n  content: \"\\e907\";\n}\n.icon-palette:before {\n  content: \"\\e908\";\n}\n.icon-lightbulb-on:before {\n  content: \"\\e909\";\n}\n.icon-info-circle:before {\n  content: \"\\e90a\";\n}\n.icon-graduation-cap:before {\n  content: \"\\e90b\";\n}\n.icon-edit-copy:before {\n  content: \"\\e90c\";\n}\n.icon-download-copy:before {\n  content: \"\\e90d\";\n}\n.icon-circle-arrow-right:before {\n  content: \"\\e90e\";\n}\n.icon-circle-arrow-left:before {\n  content: \"\\e90f\";\n}\n.icon-chevron-left:before {\n  content: \"\\e910\";\n}\n.icon-chevron-right:before {\n  content: \"\\e919\";\n}\n.icon-briefcase:before {\n  content: \"\\e911\";\n}\n.icon-brain:before {\n  content: \"\\e912\";\n}\n.icon-star-icon:before {\n  content: \"\\e913\";\n}\n.icon-eye-slash:before {\n  content: \"\\e914\";\n}\n.icon-eye:before {\n  content: \"\\e915\";\n}\n.icon-download-2:before {\n  content: \"\\e916\";\n}\n.icon-tick-light:before {\n  content: \"\\e917\";\n}\n.icon-download:before {\n  content: \"\\e918\";\n}\n.icon-trash:before {\n  content: \"\\e919\";\n}\n.icon-link:before {\n  content: \"\\e91a\";\n}\n.icon-file-text:before {\n  content: \"\\e91b\";\n}\n.icon-edit:before {\n  content: \"\\e91c\";\n}\n.icon-arrow-down-light:before {\n  content: \"\\e91d\";\n}\n.icon-arrow-up-light:before {\n  content: \"\\e91e\";\n}\n.icon-cross-icon:before {\n  content: \"\\e91f\";\n}\n.icon-double-arrow-left:before {\n  content: \"\\e920\";\n}\n.icon-Ellipse-20:before {\n  content: \"\\e921\";\n}\n.icon-plus-icon:before {\n  content: \"\\e922\";\n}\n.icon-search-icon:before {\n  content: \"\\e923\";\n}\n.icon-copy:before {\n  content: \"\\e924\";\n}\n.icon-double-arrow-right:before {\n  content: \"\\e925\";\n}\n.icon-calander:before {\n  content: \"\\e926\";\n}\n.icon-grid:before {\n  content: \"\\e927\";\n}\n.icon-languages .path1:before {\n  content: \"\\e928\";\n  color: rgb(0, 244, 217);\n}\n.icon-languages .path2:before {\n  content: \"\\e929\";\n  margin-left: -1em;\n  color: rgb(0, 244, 217);\n}\n.icon-languages .path3:before {\n  content: \"\\e92a\";\n  margin-left: -1em;\n  color: rgb(0, 145, 255);\n}\n.icon-languages .path4:before {\n  content: \"\\e92b\";\n  margin-left: -1em;\n  color: rgb(42, 100, 173);\n}\n.icon-volunteers .path1:before {\n  content: \"\\e92c\";\n  color: rgb(0, 244, 217);\n}\n.icon-volunteers .path2:before {\n  content: \"\\e92d\";\n  margin-left: -1.0439453125em;\n  color: rgb(0, 244, 217);\n}\n.icon-volunteers .path3:before {\n  content: \"\\e92e\";\n  margin-left: -1.0439453125em;\n  color: rgb(0, 145, 255);\n}\n.icon-volunteers .path4:before {\n  content: \"\\e92f\";\n  margin-left: -1.0439453125em;\n  color: rgb(0, 145, 255);\n}\n.icon-references .path1:before {\n  content: \"\\e930\";\n  color: rgb(0, 244, 217);\n}\n.icon-references .path2:before {\n  content: \"\\e931\";\n  margin-left: -0.919921875em;\n  color: rgb(0, 145, 255);\n}\n.icon-references .path3:before {\n  content: \"\\e932\";\n  margin-left: -0.919921875em;\n  color: rgb(42, 100, 173);\n}\n.icon-references .path4:before {\n  content: \"\\e933\";\n  margin-left: -0.919921875em;\n  color: rgb(0, 145, 255);\n}\n.icon-references .path5:before {\n  content: \"\\e934\";\n  margin-left: -0.919921875em;\n  color: rgb(42, 100, 173);\n}\n.icon-accomplishments .path1:before {\n  content: \"\\e935\";\n  color: rgb(0, 244, 217);\n}\n.icon-accomplishments .path2:before {\n  content: \"\\e936\";\n  margin-left: -0.599609375em;\n  color: rgb(0, 145, 255);\n}\n.icon-accomplishments .path3:before {\n  content: \"\\e937\";\n  margin-left: -0.599609375em;\n  color: rgb(42, 100, 173);\n}\n.icon-certificates .path1:before {\n  content: \"\\e938\";\n  color: rgb(0, 145, 255);\n}\n.icon-certificates .path2:before {\n  content: \"\\e939\";\n  margin-left: -1em;\n  color: rgb(0, 145, 255);\n}\n.icon-certificates .path3:before {\n  content: \"\\e93a\";\n  margin-left: -1em;\n  color: rgb(0, 145, 255);\n}\n.icon-certificates .path4:before {\n  content: \"\\e93b\";\n  margin-left: -1em;\n  color: rgb(0, 244, 217);\n}\n.icon-certificates .path5:before {\n  content: \"\\e93c\";\n  margin-left: -1em;\n  color: rgb(0, 244, 217);\n}\n.icon-certificates .path6:before {\n  content: \"\\e93d\";\n  margin-left: -1em;\n  color: rgb(0, 244, 217);\n}\n.icon-certificates .path7:before {\n  content: \"\\e93e\";\n  margin-left: -1em;\n  color: rgb(42, 100, 173);\n}\n.icon-custom .path1:before {\n  content: \"\\e93f\";\n  color: rgb(0, 145, 255);\n}\n.icon-custom .path2:before {\n  content: \"\\e940\";\n  margin-left: -1.0419921875em;\n  color: rgb(0, 145, 255);\n}\n.icon-custom .path3:before {\n  content: \"\\e941\";\n  margin-left: -1.0419921875em;\n  color: rgb(0, 244, 217);\n}\n.icon-custom .path4:before {\n  content: \"\\e942\";\n  margin-left: -1.0419921875em;\n  color: rgb(42, 100, 173);\n}\n.icon-custom .path5:before {\n  content: \"\\e943\";\n  margin-left: -1.0419921875em;\n  color: rgb(0, 145, 255);\n}\n.icon-custom .path6:before {\n  content: \"\\e944\";\n  margin-left: -1.0419921875em;\n  color: rgb(0, 145, 255);\n}\n.icon-custom .path7:before {\n  content: \"\\e945\";\n  margin-left: -1.0419921875em;\n  color: rgb(0, 244, 217);\n}\n.icon-custom .path8:before {\n  content: \"\\e946\";\n  margin-left: -1.0419921875em;\n  color: rgb(42, 100, 173);\n}\n.icon-custom .path9:before {\n  content: \"\\e947\";\n  margin-left: -1.0419921875em;\n  color: rgb(0, 145, 255);\n}\n.icon-custom .path10:before {\n  content: \"\\e948\";\n  margin-left: -1.0419921875em;\n  color: rgb(0, 145, 255);\n}\n.icon-custom .path11:before {\n  content: \"\\e949\";\n  margin-left: -1.0419921875em;\n  color: rgb(0, 244, 217);\n}\n.icon-custom .path12:before {\n  content: \"\\e94a\";\n  margin-left: -1.0419921875em;\n  color: rgb(42, 100, 173);\n}\n.icon-comment-dots:before {\n  content: \"\\e94b\";\n  color: #0091ff;\n}\n.icon-apple .path1:before {\n  content: \"\\e94c\";\n  color: rgb(40, 53, 68);\n}\n.icon-apple .path2:before {\n  content: \"\\e94d\";\n  margin-left: -1.0478515625em;\n  color: rgb(255, 255, 255);\n}\n.icon-Facebook .path1:before {\n  content: \"\\e94e\";\n  color: rgb(0, 0, 0);\n}\n.icon-Facebook .path2:before {\n  content: \"\\e94f\";\n  margin-left: -1em;\n  color: rgb(247, 247, 247);\n}\n.icon-google .path1:before {\n  content: \"\\e950\";\n  color: rgb(66, 133, 244);\n}\n.icon-google .path2:before {\n  content: \"\\e951\";\n  margin-left: -0.9501953125em;\n  color: rgb(52, 168, 83);\n}\n.icon-google .path3:before {\n  content: \"\\e952\";\n  margin-left: -0.9501953125em;\n  color: rgb(251, 188, 5);\n}\n.icon-google .path4:before {\n  content: \"\\e953\";\n  margin-left: -0.9501953125em;\n  color: rgb(235, 67, 53);\n}\n.icon-tick-small:before {\n  content: \"\\e954\";\n  color: #246eed;\n}\n.icon-blank-rating:before {\n  content: \"\\e956\";\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
